export { default as OpenAnalytics } from "./OpenAnalytics";
export { default as GeoAnalytics } from "./GeoAnalytics";
export { default as CampaignOverview } from "./CampaignOverview";
export { default as ClickAnalytics } from "./ClickAnalytics";
export { default as DeviceAnalytics } from "./DeviceAnalytics";
export { default as DomainStatCard } from "./DomainStatCard";
export { default as SentEmailsDomainCard } from "./SentEmailsDomainCard";

// Domain colors for consistent styling across components
export const domainColors = {
  gmail: "#DB4437",
  yahoo: "#720e9e",
  hotmail: "#0078D4",
  outlook: "#0072C6",
  aol: "#31459B",
  icloud: "#999999",
  protonmail: "#8A6EFF",
  zoho: "#C52F24",
  mail: "#FF5A5F",
  yandex: "#FFCC00",
  gmx: "#FC5900",
  other: "#1890ff",
};
